import * as Yup from "yup";
import { validatePositiveNumber } from "@pages/activityBuilder/modules/moduleUtils";
import { Project, ChangeRate } from "./setupAssistantMachine.types";

export const createValidationSchema = (project: Project) => {
  return Yup.object({
    activityTitle: Yup.string().required(),
    duration: validatePositiveNumber.required().test(
      "start-year-duration-check",
      "validations.activity_start_year_duration_check",
      function (value) {
        const { startYear } = this.parent;
        return (startYear + (value as number)) <= project.start_year_of_activities + project.implementation_years;
      }
    ),
    climate: validatePositiveNumber.required(),
    moisture: validatePositiveNumber.required(),
    startYear: validatePositiveNumber.required().min(1900).test(
      'start-year-check', 
      'validations.activity_start_year',
      (value) => (value as number) >= project.start_year_of_activities
    ),
    last_year_of_accounting: validatePositiveNumber.required()
      .test(
        'ly-check',
        'validations.activity_last_year_of_accounting2',
        function(value) {
          const { duration, startYear } = this.parent;
          return (value as number) >= startYear + duration;
        }
      )
      .test(
        'ly-check',
        'validations.activity_last_year_of_accounting',
        value => (value as number) <= project.last_year_of_accounting
      ),
    changeRate: validatePositiveNumber.required(),
    activityCost: validatePositiveNumber.required()
  });
};

export const createInitialValues = (project: Project, defaultChangeRate?: ChangeRate) => {
  const { 
    climate, 
    implementation_years, 
    moisture, 
    start_year_of_activities, 
    last_year_of_accounting 
  } = project;

  return {
    activityTitle: undefined,
    duration: implementation_years,
    climate: climate?.id,
    moisture: moisture?.id,
    soc_t2: null,
    startYear: start_year_of_activities,
    last_year_of_accounting,
    activityCost: 0,
    changeRate: defaultChangeRate?.id
  };
}; 